import { useDispatch } from "react-redux";
import { showModal } from "../../../../../store/modalSlice";
import { MODAL_ID } from "../../../../../utils/constants";

/**
 * @desc Add new product handler.
 */
export const useHandlers = () => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Show Modal for input SKU.
   */
  const showInputSKUModal = () => {
    dispatch(
      showModal({
        id: MODAL_ID.ADD_NEW_PRODUCT,
      })
    );
  };

  // HOOK ---------------------------------------------------------------------

  return {
    onAddProduct: showInputSKUModal,
  };
};

export default useHandlers;
